/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import * as XLSX from 'xlsx';

import { defaultExcelColumns, ExcelRowType } from './AffiliateAdminTypes';

export const downloadSampleTemplate = (data?: ExcelRowType[], name?: string) => {
  const sampleData = [
    {
      'First Name': undefined,
      'Last Name': undefined,
      ...defaultExcelColumns,
      Network: undefined,
      'PCP (Yes/No)': undefined,
      'Medical Group': undefined,
    },
  ];
  const ws = XLSX.utils.json_to_sheet(data?.length ? data : sampleData);
  // Set column widths (in characters)
  const columnWidths = [
    { wch: 25 }, // 'First Name'
    { wch: 25 }, // 'Last Name'
    { wch: 25 }, // 'Email'
    { wch: 15 }, // 'NPI'
    { wch: 15 }, // 'Specialty'
    { wch: 15 }, // 'Network'
    { wch: 15 }, // 'PCP'
    { wch: 15 }, // 'Degree'
    { wch: 15 }, // 'Medical Group'
  ];

  // Apply the column widths
  ws['!cols'] = columnWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Template');
  XLSX.writeFile(wb, name || 'bulk_upload_template.xlsx');
};
